<template>
  <div class="bg-dim flex-col">
    <div class="safe-area absolute">
      <div class="popup-wrap">
        <div>
          <div>
            <img src="@/assets/images/pw-alert.svg" alt="" />
          </div>
          <span v-html="message" class="text" />
        </div>
      </div>

      <div class="button-wrap">
        <button class="button-bg-yellow border-round" @click="confirmEvent()">확인</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'passwordAlertPopup',
  props: ['message'],
  components: {},
  data() {
    return {};
  },
  methods: {
    confirmEvent() {
      this.$emit('confirmPopupClickConfirm', 'confirm');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/pages/cards/pwSetupPopup.scss';
:deep(em) {
  color: #d73700;
}
</style>
